var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-main" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.imagePreviewVisible,
            expression: "!imagePreviewVisible",
          },
        ],
        staticClass: "c-main__menu",
      },
      [
        _c(
          "Menu",
          _vm._g(_vm._b({}, "Menu", _vm.$attrs, false), _vm.$listeners)
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "c-main__content",
        class: { "is-preview": _vm.imagePreviewVisible },
      },
      [
        _c(
          "Content",
          _vm._g(
            _vm._b(
              {
                on: {
                  "open-image-preview": _vm.handleOpenImagePreview,
                  "open-file-preview": _vm.handleOpenFilePreview,
                },
              },
              "Content",
              _vm.$attrs,
              false
            ),
            _vm.$listeners
          )
        ),
      ],
      1
    ),
    _vm.imagePreviewVisible
      ? _c("div", { staticClass: "c-main__preview" }, [
          _c("div", { staticClass: "preview-header" }, [
            _c("span", { staticClass: "preview-title" }, [
              _vm._v(
                _vm._s(_vm.previewType === "image" ? "图片预览" : "文件预览")
              ),
            ]),
            _c("i", {
              staticClass: "el-icon-close",
              on: { click: _vm.handleClosePreview },
            }),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.previewType === "file" && _vm.previewLoading,
                  expression: "previewType === 'file' && previewLoading",
                },
              ],
              staticClass: "preview-content",
            },
            [
              _vm.previewType === "image"
                ? [
                    _c("img", {
                      staticClass: "preview-image",
                      attrs: {
                        src: _vm.currentPreviewImage.url,
                        alt: _vm.currentPreviewImage.name,
                      },
                    }),
                  ]
                : [
                    _c("iframe", {
                      staticClass: "preview-iframe",
                      attrs: {
                        src: _vm.currentPreviewImage.url,
                        frameborder: "0",
                      },
                    }),
                  ],
              _c("div", { staticClass: "preview-info" }, [
                _c("p", { staticClass: "image-name" }, [
                  _vm._v(_vm._s(_vm.currentPreviewImage.name)),
                ]),
              ]),
            ],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }